import { useQuery } from '@tanstack/react-query';

import { getAccountRelated } from '~/services/ContractingService';

import { accountQueryKeys } from './accountQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetAccountRelated(accountId: string | undefined) {
  return useQuery({
    queryKey: accountQueryKeys.related(accountId ?? ''),
    queryFn: ({ signal }) => getAccountRelated(accountId ?? '', { signal }),
    enabled: !!accountId,
    retry: retryUnlessRejected,
  });
}
